import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
import { generateCSSBreakpointMapForImages } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Banner/ByType/utils";
var DEFAULT_MOBILE_IMAGE_WIDTH = 375;
var MOBILE_BANNER_IMAGE_HEIGHT = 200;
var TABLET_BANNER_IMAGE_HEIGHT = 240;
var DESKTOP_BANNER_IMAGE_HEIGHT = 320;
var MAX_BANNER_WIDTH = 1920;
export var FullWidthImageBanner = function() {
    var layoutElement = React.useContext(Context).layoutElement;
    var images = generateCSSBreakpointMapForImages(layoutElement.images);
    var isSSR = useIsSSR();
    var isMobile = useViewport().isMobile;
    var mobileImage = images.mobile;
    var backgroundImage = useResponsiveValue({
        mobileAndAbove: mobileImage,
        tabletAndAbove: images.tablet,
        desktopAndAbove: images.desktop,
        xLargeAndAbove: images.xlarge
    });
    var _mobileImage_height;
    var defaultBannerImageHeight = useResponsiveValue({
        mobileAndAbove: (_mobileImage_height = mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.height) !== null && _mobileImage_height !== void 0 ? _mobileImage_height : MOBILE_BANNER_IMAGE_HEIGHT,
        tabletAndAbove: TABLET_BANNER_IMAGE_HEIGHT,
        desktopAndAbove: DESKTOP_BANNER_IMAGE_HEIGHT
    });
    var _backgroundImage_height;
    var layoutImageHeight = (_backgroundImage_height = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.height) !== null && _backgroundImage_height !== void 0 ? _backgroundImage_height : defaultBannerImageHeight;
    var _mobileImage_width, _mobileImage_height1;
    var mobileAspectRatio = ((_mobileImage_width = mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.width) !== null && _mobileImage_width !== void 0 ? _mobileImage_width : DEFAULT_MOBILE_IMAGE_WIDTH) / ((_mobileImage_height1 = mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.height) !== null && _mobileImage_height1 !== void 0 ? _mobileImage_height1 : MOBILE_BANNER_IMAGE_HEIGHT);
    return /*#__PURE__*/ _jsxs(FullWidthImageWrapper, {
        $height: layoutImageHeight,
        $mobileAspectRatio: mobileAspectRatio,
        children: [
            /*#__PURE__*/ _jsx(Image, {
                src: optimizeImageUrl(backgroundImage !== null && backgroundImage !== void 0 ? backgroundImage : {
                    url: EAEAEA_PIXEL
                }, isSSR, {
                    height: layoutImageHeight
                })
            }),
            layoutElement.main_text ? /*#__PURE__*/ _jsx(StyledHeader, {
                color: layoutElement.main_text_color,
                variant: isMobile ? "displaySSerifRegular" : "displayLSerifRegular",
                align: "center",
                children: layoutElement.main_text
            }) : null
        ]
    });
};
var FullWidthImageWrapper = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-7eb761d6-0"
})([
    "position:relative;width:100%;padding:",
    ";",
    "{height:",
    "px;padding:0;max-width:",
    "px;margin:0 auto;}",
    "{aspect-ratio:",
    ";}"
], getSpacing(12), responsiveMediaQueries.tabletAndAbove, function(param) {
    var $height = param.$height;
    return $height;
}, MAX_BANNER_WIDTH, responsiveMediaQueries.mobile, function(param) {
    var $mobileAspectRatio = param.$mobileAspectRatio;
    return $mobileAspectRatio;
});
var Image = styled.img.withConfig({
    componentId: "sc-7eb761d6-1"
})([
    "width:100%;height:100%;object-fit:cover;object-position:center;position:absolute;top:0;left:0;"
]);
var StyledHeader = styled(Typography).withConfig({
    componentId: "sc-7eb761d6-2"
})([
    "z-index:1;"
]);
